import type { IConfig } from "./IConfig";

class EnvBasedConfig implements IConfig {
    public apiUrl: string;

    public apiHostName: string;

    public environment: string;

    public launchDarklySdkKey: string;

    public googleMapsApiKey: string;

    constructor() {
        if ((window as any).__env) {
            const env: IConfig = (window as any).__env;
            Object.assign(this, env);
        } else {
            throw Error("Environment (window.__env) not set!");
        }
    }
}

export const Config: IConfig = {
    ...new EnvBasedConfig(),
};
